function Gallery(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var swiperContainer;
	var swiper;
	var galleryId;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function initThumbnails(){
		var spaceDefault = 10;
		var spaceSmall = 6;
		var buttonLeft = '#gallery-button-left-' + galleryId;
		var buttonRight = '#gallery-button-right-' + galleryId;
		
		swiper = new Swiper(swiperContainer, {
			navigation: {
				nextEl: buttonRight,
				prevEl: buttonLeft,
			},
			slidesPerView: 5,
			spaceBetween: spaceDefault,
			// Responsive breakpoints
			breakpoints: {
				400: {
					slidesPerView: 2,
					spaceBetween: spaceSmall
				},
				560: {
					slidesPerView: 3,
					spaceBetween: spaceSmall
				},
				767: {
					slidesPerView: 4,
					spaceBetween: spaceDefault
				},
				999: {
					slidesPerView: 4,
					spaceBetween: spaceDefault
				}
			}
		});
	}
	
	
	function initPopup(){
		swiperContainer.magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true,
				tCounter: '<span class="mfp-counter">%curr%/%total%</span>',
				tPrev: 'Předchozí',
				tNext: 'Další',	
			},
			
			image: {
				titleSrc: 'title'
			},
			
			callbacks: {
				updateStatus: function (data) {
					// change loading text
					data.text = 'Načítám&hellip;';
				}
			}
			
		});
	}
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			swiperContainer = $('.swiper-container', _this.container);
			galleryId = _this.container.data('id');
		
			// init
			initThumbnails();
			initPopup();
			
			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
